import { useEffect } from 'react'
import OktaAuth from '@okta/okta-auth-js'
import { routes } from 'config'

import { oidcImpersonateGatewayConfig } from 'config/'

const GatewayCallback = () => {
  useEffect(() => {
    const authClient = new OktaAuth(oidcImpersonateGatewayConfig)
    authClient.token.parseFromUrl().then((idToken: any) => {
      console.log(
        'Success! Redirecting to: ' + process.env.REACT_APP_DEFAULT_REDIRECTION,
        idToken,
      )
      document.location.href = routes.BCOM.login
    })
  })

  return null
}

export default GatewayCallback
